/* LB-POPUP ban .COM (16/09/2026) — thay Alia tren litborne.com. Tach file khoi ban .co.
   Khac ban .co: Klaviyo TZvNjp + list "Alia Email" (WiHi2p) de flow dang chay tiep tuc nhan khach;
   property Klaviyo NGUYEN VAN nhu Alia ("Answer this question to start: ..."); OTP CHI cho US,
   nuoc khac nhap sdt xong vao thang man cuoi; may chu api.litborne.com.
   Goc: clone co che popup Alia cho litborne.co, 0 app fee.
   3 step: Quiz -> Email -> Reward (reveal WELCOME10 + auto-ap /discount/).
   Trigger (OR): 30s on page | scroll 50% | exit-intent (desktop) | quick scroll-up (mobile).
   Targeting: new visitor (chua signup, khong o /account|/checkout|/cart, khong tu utm email/sms).
   Dismiss -> floating pill 7 ngay; signup -> tat vinh vien. Debug: ?lbpopup=1 ep mo, =0 tat. */
(function () {
  'use strict';

  /* Ma khach dung chung voi script theo doi (lb-px.js) va Web Pixel checkout. 26/09: Shopify bo cookie
     _shopify_y tu 25/09 07:00 LA -> truoc day doc cookie khong ra la BO QUA, popup van hien nhung kho
     khong ghi duoc lan hien / buoc / lead nao. Thu tu: cookie cu -> uniqToken cua Shopify -> ma tu sinh. */
  function maKhach(cookieCu) {
    if (cookieCu) return cookieCu;
    try {
      var t = window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.user && ShopifyAnalytics.lib.user().traits().uniqToken;
      if (t) return String(t);
    } catch (e) {}
    /* 27/09: ma chinh thuc do Web Pixel ghi (event.clientId) — dung khi uniqToken bien mat */
    try { return localStorage.getItem('_lbx_sy') || localStorage.getItem('_lbx_id') || ''; } catch (e) { return ''; }
  }
  if (window.__lbPopupBoot) return; window.__lbPopupBoot = 1;

  /* TZvNjp = account cua litborne.com (VW4Rq6 la .co — KHONG dung nham).
     WiHi2p = list "Alia Email" ma Alia dang ghi vao — giu nguyen list de flow/segment khong doi. */
  var KLAVIYO_COMPANY = 'TZvNjp';
  var KLAVIYO_LIST = 'WiHi2p';
  var CODE = 'WELCOME10';
  var STATE_KEY = 'lb-popup-state';
  var DISMISS_DAYS = 7;

  function qs(k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } }
  function st() { try { return JSON.parse(localStorage.getItem(STATE_KEY) || '{}'); } catch (e) { return {}; } }
  function setSt(patch) {
    try { var s = st(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
  }
  function assetUrl(name) {
    var me = document.querySelector('script[src*="lb-popup"]');
    if (!me) return name;
    return me.src.replace(/lb-popup\.js[^?]*/, name).split('?')[0] + (me.src.match(/\?v=[^&]+/) ? me.src.match(/\?v=[^&]+/)[0] : '');
  }

  /* ---------- gate ---------- */
  var debug = qs('lbpopup');
  if (debug === '0') return;
  var s0 = st();
  if (debug !== '1') {
    if (s0.signedUp) return;
    if (/^\/(account|checkout|cart|thank_you|challenge)/.test(location.pathname)) return;
    var utm = (qs('utm_source') || '') + ' ' + (qs('utm_medium') || '');
    if (/klaviyo|email|sms|text/i.test(utm)) return; /* khach tu email/sms = da co contact */
  }
  var dismissedRecently = s0.dismissedAt && (Date.now() - s0.dismissedAt < DISMISS_DAYS * 864e5);

  /* ---------- styles ---------- */
  var GOLD = '#C9A55A', INKBTN = '#1a1610';
  /* Co quoc gia dang PNG w40 nhung thang vao file (~4.5KB ca 15 la).
     Khong dung emoji: Windows khong co font co -> ra o vuong.
     Khong goi CDN: mat mang la mat co. Khong dung SVG: rieng co ES nang 153KB. */
var CO = {"US":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVBAMAAADGNLEtAAAALVBMVEX////GU3LZjKGzGUINM2PsxtAYPWotT3hed5enma46WoBPa46zGkMkR3Jrgp+6ntXWAAAAiklEQVQY02Nwc0lJcQMSxghgw+CRVdaWkVXWooQEGFxaPLxKWjxcGJCBn1fJExAWRAJglUuAKlEEPdyXgA1A0e62LTu9bFt2CopF3iCh9LItKE5yX5tVe31tVgmq9pL0NLcy95RQJMAAdiUQo2ifCQUoKrECY0xgw6CEBWDXLogFYBfECrBahM1JAItMTcEiMDpsAAAAAElFTkSuQmCC","CA":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAASFBMVEX/////ubn/oqL/Z2f/Jib/09P/7e3/AAD/+/v/Gxv/W1v/rq7/eXn/nZ3/DAz/OTn/AwP/Pj7//Pz/QED/PT3/g4P/xsb/xcWY5npoAAAAkUlEQVQoz43TyQ7DIAxFUQbDNZCx4///aTdt00ohsXdPHIFsGce33E79nO5AvRjhGCxQVYs41fMbpUIVw9MzwHwKk4sA0aUj6IdW7iNAGEobfBfmBbgC3IAld6HKllhEuzDwV6HfjJ+2OPmjrlP5pJKOx5PfsuSTOWZZY61xlWxYiufDuD3eG2FrRpiSEe5+hRcblQ+AegtNbgAAAABJRU5ErkJggg==","GB":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAANlBMVEX////w8vfyxcx8jbJCWpAOLHFVa5sBIWnIEC7WTGLnv8qAkLTheYpecqHx0digrMfz3+T21dqBS5WQAAAApUlEQVQoz8WTyxpFMAyEpyqOuhTv/7IntImmurAzC59kfsIIhA5wnn6iASMLgzbIT2Fk6joUaAUKBsiJm+kJ0iyuR1mQBam8Cex1dINkZ6EesSZwrR8JfdYWl7AcbCRw5ypytYmPpy6w3X6jL8HXL6PxOODgTPYEcnXmFe94cuBsdJzwpIFrRwK3WPkJLQqL2aUoUVisXjOvLizWWNyMVljrV0gz/wdhEi0lRIbcAAAAAElFTkSuQmCC","IE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUBAMAAAANaGKIAAAAD1BMVEUWm2L/iD7///+y3sv/174BQJ8QAAAAGElEQVQY02NgAANmJTBwFAQDhlHBwSQIALIxHTlPIfkHAAAAAElFTkSuQmCC","AU":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAdVBMVEUBIWn+/v8LKm8rRoLsS2lZa5sCI2rkACvAyNojP317jLGrtc2qtc3FzN1fc6FBWY/5w83ecIr+8vQRL3P5x9DY3ejU2OVeZpZLVIn709oYNndNZJacqcWLmrra3unVZ4Xy9Pj22uFEXJHIz94VM3XUZYPb3+rlcwqvAAAAz0lEQVQoz7WQyRKDIBBEB2STRHHfTdQs//+JQVxiSlNFDunLAPOomW4gycVnAHDi/KwLoyEJ4EjFgyQpXcBcY54C+IpmdAQNNmxavv8+C62sLyPEeVRGXTbelx72BF5BfqC16bpgB25lRnd6KucoKvuP0UaOdObT4CUkzEczNA3ItZheq2oxhKYUlMHmeNiK4ps3+7jXzFSN0W3g/jMgY5WSwS+i1BLcBrS4c6x+xrJpZGxDtgi1NpwSCAlls44rxG5vfEnxHozjvUFaw//0ApepC3HnUeodAAAAAElFTkSuQmCC","DE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYAgMAAAD16ldTAAAACVBMVEUAAADdAAD/zgDGIigcAAAAFUlEQVQY02NgoBEIhQPqMlfBAVWZANYST7G6bxb2AAAAAElFTkSuQmCC","FR":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbBAMAAAD8PtBdAAAAD1BMVEUAJlT////OESbvr7aqtsYrjF9NAAAAGUlEQVQoz2NgAAMWQTAwUgIDhlHBUUG8ggBpKyX5efKDZQAAAABJRU5ErkJggg==","ES":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAMAAAA5zj1cAAAApVBMVEX6vQCtFRnBPxP3tgCkSRTxsQC9miCtkjL3ugDcdwrVkwndpwauUEi3k3ecLQyvGx01YomtXy3Zhha+gw+4LiCzn4jKeBKyYgjmoAOkXUK/RhC1kJmmKh+0oKCbYwN5OAWWHxSVi0HypQNcdGsDAgC9g1j6vgSWhnLfsSXCn169cE24eBuaNwzQaiOYagW8bxWIOhqoKhPLdq4yUHR+UgVZLWaBHkAs3esWAAAAk0lEQVQ4y+WTVxLDIAxESQwBAwb33tKc3sv9j5YbWJp8JvurNzsrzYpMkCI/BU6RIt9phqIcJSOpEGBu7c2WA+iXOWmbtTmTACh42PdelSgwp+d2nXdvTjuAc3X5vL6qJo4XQEZ9qd8PXaR7yDE5GFOf6XbNRrmB8cgcKaUraJm5z4NiE4RLH3FyIUaG6Pb85XN9AIg9CvrV7UGSAAAAAElFTkSuQmCC","IT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbBAMAAAD8PtBdAAAAElBMVEXOKzcAkkb///+q28EBkkbvt7tlcfnnAAAAGUlEQVQoz2NwFAQBYSUwCGCAgFHBUUG8ggBTFC/I4rFoIQAAAABJRU5ErkJggg==","PT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAMAAAA5zj1cAAAA3lBMVEX/AAAAZgDjeAn6AAAEYwDcogDtUwqbtwDmXhr5QT76fHz+/v62xOLf5PJ6pgC/zgCpvAD1LwCYswCjuADuYyutwwD6MC/1ZwDXxADjjADuSgDsAADllgDkqgDo3wDkswDvIwDZ1wDSqQBclgDopwDpxADoaxJ+rADcjwreTADrNwCKqwA1fgBRhgDM0gAZbQDq6gDrOgD8EhLvRAr22M3qk1L6OTbsfip4lMmZrNg7hADjFADRggDyBADkmDXcvzH0dFOTrhryRjl9jiS2ozbcXEvrMwAAWgDz9fry9PltbfP7AAAA0ElEQVQ4y+XTxxKCQBAEUNgl56CIAZUgihkQzDn//w95t8rBs/b5naZ7CPItxKf8MKRGEf4CDstl0+s47SLYNaj7KKqvexUYDjTuhuMY9zkvhOBkOg0ZIcsEJtzYGICKMbZ4UZJE3toiBoAGq3ElUZbFEkdXEQDH7ATNF8vlYo7ajg1AljXz/CnLD4unG1UA+gp11WeSNNMPnaAGQMo1zygVhBTtm806dEdFHVxOScLvWi5d0Iw2JI+9fq1RKep6paoaHbT0b9bjM/j/fuYzfAEwIRPN3DfXmAAAAABJRU5ErkJggg==","AT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbAQMAAAA03l8tAAAABlBMVEXIEC7///94b0yLAAAAEklEQVQI12NgIAv8BwGSSbIAADA3LNT5TsD+AAAAAElFTkSuQmCC","BE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAjBAMAAAAUF1WdAAAAD1BMVEXvM0AAAAD92iX4oi2okRgdxzYaAAAAGUlEQVQoz2MQBAMRJTAwYICAUcFRwWEhCADCrTMjCu9IjwAAAABJRU5ErkJggg==","SE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAZAgMAAAA+toT2AAAACVBMVEUAUpP+ywB/j0kXq4KkAAAAGklEQVQY02NgYGCYmsAAA7RmhsIBSUy6OhIASfMjv9uXrDcAAAAASUVORK5CYII=","CH":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAElBMVEX/AAD/////wMD/gID/YGD/8PBDRn5nAAAANklEQVQoz2NgGLzA2djYBENQUVBQaJALsigBQaCgoCiIdoAKMgsiAQN6C2J10lAJT9yJYfAAAHGvEL146aHXAAAAAElFTkSuQmCC","MT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbBAMAAAD8PtBdAAAAIVBMVEX////PFCv5+fn04OPw29758vPl5eX77u/sztLd3d3g4OCFpgNSAAAARUlEQVQoz2NggANBOGBgYHUJwBRkVjLAEGS1mNYcgC7Iohaa5IAhqKWEKcjukdZSQJRFDOzGBZiCDApYHI/VR6OC1BQEABQgGV7i2R6rAAAAAElFTkSuQmCC"};
  var css = '' +
    '#lb-pop{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;font-family:var(--font-body--family,system-ui,sans-serif)}' +
    '#lb-pop[hidden]{display:none!important}' +
    /* Lop toi phang chong len anh: mau nen phai nam o LAYER CUOI khi dung nhieu lop background */
    '#lb-pop .lbp-bg{position:absolute;inset:0;background:linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),url(' + JSON.stringify(assetUrl('lb-popup-bg.webp')) + ') 50%/cover no-repeat #000}' +
    /* Card KHONG duoc co nen rieng: card chi rong 560px giua man hinh rong, dat lop phu o day
       thi no thanh vet toi hinh bau duc lo lung, nhin ro mep — xau. Lop phu nam o .lbp-bg (phu kin
       toan man) de toi DEU, khong co mep nao de nhin thay. */
    '#lb-pop .lbp-card{position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;gap:.65rem;width:100%;max-width:560px;padding:2rem 1.25rem;color:#fff}' +
    '#lb-pop .lbp-x{position:fixed;top:14px;left:14px;z-index:3;width:38px;height:38px;border:0;border-radius:50%;background:#1d2333;color:#fff;font-size:17px;line-height:38px;cursor:pointer}' +
    '#lb-pop .lbp-logo{width:150px;margin-bottom:.4rem}' +
    '#lb-pop .lbp-h2{font-family:"Playfair Display",Georgia,serif!important;font-size:clamp(30px,4.5vw,48px);line-height:1.1;letter-spacing:-1px;margin:0;color:#fff!important;text-shadow:0 2px 16px rgba(0,0,0,.75)}' +
    /* color PHAI !important: man reward dung the <h2> mang class nay, ma .co con rule
       h2{color:var(--lb-text)!important} tu dot lat nen trang -> muc den de len nen toi = mat hut.
       Tren .com khong co rule do nen vang van an — cung mot code, hai ket qua khac nhau.
       Day la lan thu BA dinh bay "theme dat color truc tiep len the", xem .lbp-h2 va o tick. */
    '#lb-pop .lbp-h1{font-family:"Playfair Display",Georgia,serif!important;font-size:clamp(34px,5.5vw,56px);line-height:1.1;letter-spacing:-1px;margin:0;color:' + GOLD + '!important;text-shadow:0 2px 16px rgba(0,0,0,.8)}' +
    '#lb-pop .lbp-sub{font-size:16px;margin:.35rem 0 .4rem;text-shadow:0 1px 8px rgba(0,0,0,.55)}' +
    /* Nut kieu Alia: serif, title case, bo goc. Font khai cung Playfair (da nap san tren .com): theme Horizon dat font theo THE (h2->Playfair, p->Lora, !important) de len bien --font-heading--family (=Inter), lam popup tron 3 font — do 16/09. */
    '#lb-pop .lbp-btn{display:block;width:100%;max-width:18rem;padding:.9rem 1rem;border:0;border-radius:6px;background:' + GOLD + ';color:' + INKBTN + ';font-family:var(--font-heading--family,Georgia,serif);font-size:16px;font-weight:400;letter-spacing:0;text-transform:none;line-height:1.2;cursor:pointer;text-decoration:none;text-align:center;font-family:"Playfair Display",Georgia,serif!important}' +
    '#lb-pop .lbp-btn:hover{filter:brightness(1.06)}' +
    '#lb-pop .lbp-skip{background:none;border:0;color:#fff;font-size:11px;letter-spacing:.18em;text-transform:uppercase;text-decoration:underline;cursor:pointer;margin-top:.35rem}' +
    /* O nhap TRANG nhu Alia (ban cu la nen toi trong suot). !important vi theme co rule
       `input,textarea,select{background/border/color ... !important}` — di san dot lat nen trang. */
    '#lb-pop input{width:100%;max-width:18rem;padding:.85rem .9rem;border:1px solid #fff!important;border-radius:6px;background:#fff!important;color:#1a1610!important;font-size:15px}' +
    '#lb-pop input::placeholder{color:#8d8778}' +
    '#lb-pop .lbp-err{color:#ffb3ab;font-size:12px;min-height:15px;margin:0}' +
    '#lb-pop .lbp-code{font-family:monospace;font-size:26px;letter-spacing:.12em;background:rgba(255,255,255,.12);border:1px dashed ' + GOLD + ';border-radius:8px;padding:.55rem 1.1rem;user-select:all}' +
    '#lb-pop .lbp-fine{font-size:10.5px;opacity:.85;max-width:20rem;line-height:1.5;text-shadow:0 1px 6px rgba(0,0,0,.85)}' +
    '#lb-pop .lbp-fine a{color:#fff}' +
    /* Khoi dieu khoan SMS nam TREN o so dien thoai (Alia lam vay), chu hoa rat nho tren nen den.
       Day la disclosure TCPA nen bat buoc phai doc duoc ro — khong duoc de chim vao anh nen.
       color phai !important: theme dat rule color rieng cho tung the, ma rule truc tiep luon thang
       gia tri KE THUA tu .lbp-card du specificity thap hon. */
    '#lb-pop .lbp-note{max-width:18rem;background:#000;color:#fff!important;font-size:8.5px;line-height:1.45;' +
    'letter-spacing:.02em;text-transform:uppercase;text-align:center;padding:.5rem .6rem;margin:0}' +
    '#lb-pop .lbp-note a{color:#fff!important;text-decoration:underline}' +
    /* Hang so dien thoai: chon ma vung + o nhap nam chung mot khoi trang bo goc */
    '#lb-pop .lbp-ps{display:block;width:100%;max-width:22rem;margin:0 auto;text-align:center}' +
    /* dropdown fullscreen cua intl-tel-input (Postscript form, mobile) gan vao body: minh chon nuoc bang code nen KHONG hien */
    '.iti--container,.iti--fullscreen-popup{display:none!important}' +
    '#lb-pop .lbp-cclist{position:fixed;z-index:2147483647;width:240px;max-height:230px;overflow:auto;background:#fff;border-radius:8px;box-shadow:0 8px 30px rgba(0,0,0,.45);padding:6px 0;text-align:left}#lb-pop .lbp-cclist[hidden]{display:none}#lb-pop .lbp-ccitem{display:flex;align-items:center;gap:10px;width:100%;background:transparent;border:0;padding:8px 12px;font:14px/1.2 system-ui,sans-serif;color:#1a1a1a;cursor:pointer;text-shadow:none;text-align:left}#lb-pop .lbp-ccitem:hover{background:#f3efe6}#lb-pop .lbp-ccitem .lbp-flag{width:22px;height:16px;border-radius:2px}#lb-pop .lbp-ccname{flex:1}#lb-pop .lbp-ccdial{color:#777}' +
    '#lb-pop .lbp-pscc{display:flex;align-items:center;gap:6px;justify-content:center;margin:2px auto 0;position:relative;height:34px}#lb-pop .lbp-pscc select{appearance:none;-webkit-appearance:none;background:transparent;border:0;color:#fff;font:600 14px/1 system-ui,sans-serif;padding:6px 18px 6px 4px;cursor:pointer;text-shadow:0 1px 6px rgba(0,0,0,.8)}#lb-pop .lbp-pscc select option{color:#1a1a1a}#lb-pop .lbp-pscc .lbp-flag{width:22px;height:16px;border-radius:2px}#lb-pop .lbp-pscc .lbp-caret{position:static;border-color:#fff transparent transparent}' +
    '#lb-pop .lbp-tel{display:flex;align-items:stretch;width:100%;max-width:18rem;background:#fff;border-radius:6px;overflow:hidden}' +
    /* Chi hien LA CO + mui ten, KHONG hien dau so (dung kieu Alia).
       <select> that van giu nguyen de ban phim/mobile chay binh thuong, nhung cho opacity:0 va phu
       kin vung nay -> khong con duong vien nao cua select ve ra man.
       Da BO: box-shadow quanh la co va border-left ngan cach — chinh la 2 "gach doc" user thay. */
    '#lb-pop .lbp-cc{position:relative;flex:0 0 auto;display:flex;align-items:center;gap:5px;padding:0 .6rem;cursor:pointer}' +
    /* DANH SACH xo xuong do trinh duyet ve RIENG, khong an theo opacity:0 cua select —
       nen select tang hinh tren trang ma danh sach van hien, va hien bang mau theme ap vao
       (user thay chu vang kho doc chinh la cho nay). Ep chu den nen trang.
       Phai !important vi theme co rule `input,textarea,select{color/background ... !important}`. */
    '#lb-pop .lbp-cc select{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;opacity:0;cursor:pointer;border:0!important;color:#1a1610!important;background:#fff!important}' +
    '#lb-pop .lbp-cc option{color:#1a1610;background:#fff}' +
    '#lb-pop .lbp-flag{display:block;width:22px;height:16px;object-fit:cover;border-radius:2px}' +
    '#lb-pop .lbp-caret{width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:5px solid #6b6357}' +
    '#lb-pop .lbp-tel input{flex:1 1 auto;max-width:none;min-width:0;border:0!important;border-radius:0}' +
    /* 4 o ma OTP — Postscript gui ma 4 CHU SO (da xem tren .com 14/09), khong phai 6 */
    '#lb-pop .lbp-otp{display:flex;gap:.55rem;justify-content:center}' +
    '#lb-pop .lbp-otp input{width:46px!important;max-width:46px;height:52px;padding:0!important;text-align:center;font-size:22px;border-radius:6px}' +
    '#lb-pop .lbp-resend{font-size:12px;margin:.1rem 0}' +
    '#lb-pop .lbp-resend button{background:none;border:0;color:#fff;font-size:12px;text-decoration:underline;cursor:pointer;padding:0}' +
    '#lb-pop .lbp-step{display:flex;flex-direction:column;align-items:center;gap:.65rem;width:100%;animation:lbpUp .5s ease both}' +
    '@keyframes lbpUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}' +
    /* Floating button y nhu Alia (anh user 16/09): nen VANG, chu toi serif in hoa "YOU'VE GOT A GIFT! 🎁",
       goc bo nhe (khong phai vien thuoc), co dau x rieng de tat pill. Ban cu nen toi chu vang la sai. */
    '#lb-pill{position:fixed;left:16px;bottom:16px;z-index:2147482999;display:flex;align-items:center;gap:12px;border-radius:6px;background:' + GOLD + ';color:' + INKBTN + ';font-family:"Playfair Display",Georgia,serif!important;font-size:12px;letter-spacing:.06em;text-transform:uppercase;padding:.7rem .9rem .7rem 1rem;box-shadow:0 4px 14px rgba(0,0,0,.25)}' +
    '#lb-pill button{background:none;border:0;padding:0;margin:0;color:' + INKBTN + ';font:inherit;letter-spacing:inherit;text-transform:inherit;cursor:pointer;line-height:1.2}' +
    '#lb-pill .lbp-pill-x{font-family:system-ui,sans-serif;font-size:14px;opacity:.85}' +
    '@media (max-width:749px){' +
    /* Mobile PHU KIN MAN. Truoc day la kieu "bottom sheet" dan day (the co nen rieng + bo goc,
       nen chi chiem nua duoi, nua tren van thay trang web) — thiet ke cu tu 11/09, sot lai tu
       truoc dot lam giong Alia. Anh Alia o kho iPhone la phu kin ca man.
       Cach sua: anh nen mobile chuyen LEN .lbp-bg (phu toan man), the bo nen rieng + bo goc,
       va bo align-items:flex-end de the ve giua nhu desktop. */
    '#lb-pop .lbp-bg{background:linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),url(' + JSON.stringify(assetUrl('lb-popup-bg-m.webp')) + ') 50%/cover no-repeat #000}' +
    '#lb-pop .lbp-card{max-width:none;border-radius:0;padding:1.6rem 1.1rem 2rem;background:none}' +
    /* X giu kieu fixed goc man nhu desktop (Alia cung de o goc); neu de absolute theo the thi
       the ve giua se keo X lung lo giua man. Chi thu nho kich thuoc. */
    '#lb-pop .lbp-x{width:32px;height:32px;line-height:32px;font-size:15px}' +
    '}';

  function ensureCss() {
    if (document.getElementById('lb-pop-css')) return;
    var t = document.createElement('style'); t.id = 'lb-pop-css'; t.textContent = css;
    document.head.appendChild(t);
  }

  /* ---------- DOM ---------- */
  var root = null, quizAnswer = null, pendingPhone = '', emailDaNhap = '';
  var buocHienTai = '';

  /* ---------------------------- PHEU POPUP ----------------------------
     Truoc day popup chi ban 'lead' luc submit -> khong biet popup hien bao nhieu lan,
     khach chet o buoc nao, kich hoat bang gi. Khong co so nay thi khong A/B duoc
     delay/offer, ma thay WL71 noi day la cho an tien nhat.
     Di duong /px/a (hanh vi) nen KHONG BAO GIO cham Meta; cung client_id nen tu noi
     voi heatmap va voi 'lead' trong lb.v_timeline. */
  function bao(ten, chiTiet, lan, t0) {
    t0 = t0 || Date.now();
    try {
      var c = window.__lbpx || {};
      /* Cat duoi '/e' bang SO SANH CHUOI va doc cookie bang split — KHONG dung regex.
         Da bon lan dinh bay escape qua nhieu lop (heredoc long template literal an mot cap):
         /D/g -> /D/g, roi /e$ -> //e$ (mo chu thich, vo cau lenh), roi 's' mat mot cap.
         Bo han backslash thi khong con gi de mat. */
      var url = String(c.collect || 'https://api.litborne.com/px/e');
      url = (url.slice(-2) === '/e') ? url.slice(0, -2) + '/a' : url;
      var cid = '';
      var mieng = document.cookie.split(';');
      for (var i = 0; i < mieng.length; i++) {
        var kv = mieng[i].split('=');
        if (kv[0].trim() === '_shopify_y') { cid = decodeURIComponent(kv.slice(1).join('=')); break; }
      }
      cid = maKhach(cid);
      /* 27/09: chua co ma (popup mo ngay luc tai trang, pixel chua kip ghi _lbx_sy) -> CHO toi 5s roi gui,
         giu nguyen gio goc t0. Truoc day `return` luon = mat popup_show. */
      if (!cid) { if ((lan || 0) < 10) setTimeout(function () { bao(ten, chiTiet, (lan || 0) + 1, t0); }, 500); return; }
      var P = window.Shopify && window.Shopify.customerPrivacy;
      /* Doc khong ra API dong y -> COI NHU CO phan tich, dung chinh sach da chot cua du an
         ("doc khong ra thi cho chay phan phan tich, nhung KHONG ban Meta") va dung voi hai
         nguon ghi kia (theme + web pixel deu mac dinh true). Truoc day cho nay mac dinh FALSE
         nen popup tu coi khach la da tu choi roi im lang bo su kien — chi vi API privacy chua
         kip nap. Hau qua do duoc: phieu popup dem THIEU so voi thuc te, va hai script ghi cung
         mot bang lb.activity lai mac dinh nguoc nhau. Rieng `cm` van giu mac dinh FALSE. */
      var ca = P ? !!P.analyticsProcessingAllowed() : true;
      if (!ca) return;                       /* chua dong y phan tich thi khong ghi gi */
      /* Gan su kien popup vao dung TRANG va PHIEN dang dien ra. Truoc do tao de rong nen
         moi dong popup_* trong kho co page_id/session_id trong — khong noi duoc phe u popup
         voi hanh vi trong trang, mat dung kha nang ma muc 3 vua dung ra.
         Hai ma do script theme (lb-px.js) so huu; o day chi DOC. Khong dung regex. */
      var maT = '', maP = '';
      try { var oT = JSON.parse(localStorage.getItem('_lbx_pid') || 'null'); if (oT && oT.id) maT = oT.id; } catch (e) {}
      try { var oP = JSON.parse(localStorage.getItem('_lbx_sess') || 'null'); if (oP && oP.id) maP = oP.id; } catch (e) {}
      var body = {
        cid: cid, sid: maP, pid: maT,
        url: location.href.slice(0, 1000), path: location.pathname.slice(0, 300),
        vw: window.innerWidth, vh: window.innerHeight,
        country: (window.Shopify && window.Shopify.country) || '',
        ca: ca, regulation: '',
        acts: [{ t: t0, q: 1, n: ten, rg: 'popup', tx: String(chiTiet || '').slice(0, 60) }]
      };
      var j = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([j], { type: 'text/plain' }));
      else { var r = new XMLHttpRequest(); r.open('POST', url); r.setRequestHeader('Content-Type', 'text/plain'); r.send(j); }
    } catch (e) { /* do luong khong duoc lam vo popup */ }
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function headerNodes(step) {
    var frag = document.createDocumentFragment();
    var lg = el('img', 'lbp-logo'); lg.src = assetUrl('lb-popup-logo.webp'); lg.alt = 'Litborne';
    frag.appendChild(lg);
    /* Chi 2 buoc dau moi doi "You've Got / Mystery Discount"; phone, otp, reward co tieu de rieng (kieu Alia) */
    if (step === 'quiz' || step === 'email') {
      frag.appendChild(el('h2', 'lbp-h2', "You've Got"));
      frag.appendChild(el('p', 'lbp-h1', 'Mystery Discount'));
    }
    return frag;
  }
  function render(step) {
    buocHienTai = step;
    bao('popup_step', step);
    var card = root.querySelector('.lbp-card');
    card.innerHTML = '';
    /* X con cua card: desktop fixed goc man hinh, mobile absolute goc card */
    var x = el('button', 'lbp-x', '✕'); x.setAttribute('aria-label', 'Close'); x.onclick = dismiss;
    card.appendChild(x);
    var box = el('div', 'lbp-step');
    box.appendChild(headerNodes(step));

    if (step === 'quiz') {
      box.appendChild(el('p', 'lbp-sub', 'Answer this question to start: Who are you shopping for today?'));
      ['Myself', 'Someone else'].forEach(function (a) {
        var b = el('button', 'lbp-btn', a);
        b.onclick = function () { quizAnswer = a; bao('popup_answer', a); render('email'); };
        box.appendChild(b);
      });
      /* "No thanks" gach chan duoi 2 nut — y Alia (user chi 16/09). Khac nut X: bam No thanks la
         KHONG hien floating button nua; bam X thi van co floating de mo lai. */
      var khong = el('button', 'lbp-skip', 'No thanks');
      khong.onclick = noThanks;
      box.appendChild(khong);
    }

    if (step === 'email') {
      var nameI = el('input'); nameI.placeholder = 'Your name'; nameI.autocomplete = 'given-name';
      var mailI = el('input'); mailI.type = 'email'; mailI.placeholder = 'Your email address'; mailI.autocomplete = 'email';
      var err = el('p', 'lbp-err', '');
      var go = el('button', 'lbp-btn', 'Continue');
      go.onclick = function () {
        var em = (mailI.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { err.textContent = 'Please enter a valid email address.'; return; }
        go.disabled = true; go.textContent = 'One moment…';
        emailDaNhap = em;                                /* de buoc phone ghi so len dung profile Klaviyo */
        emitIdentity(em, (nameI.value || '').trim());   /* vao kho truoc, khong phu thuoc Klaviyo */
        /* Sang buoc SO DIEN THOAI chu khong nhay thang toi reward.
           Postscript bat buoc o SDT phai TACH RIENG khoi o email va hien rieng, khong gop chung. */
        subscribe(em, (nameI.value || '').trim()).then(function () {
          setSt({ signedUp: 1, signedUpAt: Date.now() });
          render('phone');
        }).catch(function (e) {
          /* van cho khach di tiep — loi mang khong duoc chan luong.
             NHUNG phai bao ra ngoai: truoc day loi Klaviyo bi nuot HOAN TOAN (khong log, khong
             gui di dau), co `syncFailed` chi duoc GHI chu khong cho nao DOC lai, ma `signedUp`
             thi khoa popup vinh vien -> khach khong vao duoc list va khong bao gio co lan thu hai,
             con minh thi khong he biet. Ban sang /px/a de no hien trong kho ma dem duoc.
             Email KHONG mat: emitIdentity() o tren da ban vao lb.events truoc khi goi Klaviyo. */
          try { bao('popup_sync_fail', String((e && e.message) || e || 'klaviyo')); } catch (e2) {}
          setSt({ signedUp: 1, signedUpAt: Date.now(), syncFailed: 1 });
          render('phone');
        });
      };
      mailI.addEventListener('keydown', function (e) { if (e.key === 'Enter') go.click(); });
      /* Alia khong co dong chu nho nao o buoc email — user chot lam y het ca phan noi dung. */
      box.appendChild(nameI); box.appendChild(mailI); box.appendChild(err); box.appendChild(go);
    }

    /* ---------------------------- BUOC SO DIEN THOAI ----------------------------
       Dung dung kieu Alia (xem 5 man that tren .com 14/09): tieu de rieng, khoi dieu khoan SMS
       nam TREN o nhap, o nhap co chon ma vung, nut "Continue".
       Dong y bang HANH DONG BAM NUT (clickwrap) chu khong phai o tick — do la mau Alia dang dung,
       ma Alia la doi tac tich hop chinh thuc cua Postscript. */
    if (step === 'phone' && khachUS() && !psFormHong && psForm(box)) {
      /* US: o so + OTP la FORM NHUNG CUA POSTSCRIPT (xem psForm). Khong dung UI cu ben duoi. */
      card.appendChild(box);
      return;
    }
    if (step === 'phone') {
      box.appendChild(el('h2', 'lbp-h2', 'Finish Signing Up'));
      box.appendChild(el('p', 'lbp-sub', 'with texts to get your mystery discount'));
      box.appendChild(el('p', 'lbp-note',
        '*By providing your number and clicking the button, you agree to receive recurring auto-dialed marketing SMS ' +
        '(including cart reminders; AI content; artificial or prerecorded voices) and our ' +
        /* /policies/terms-of-service tra 404 tren CA HAI store (da do) — trang that nam o
           /pages/terms-of-service. Alia tren .com dang link vao dung trang 404 do; khong chep lai loi. */
        '<a href="/pages/terms-of-service" target="_blank" rel="noopener">Terms of Service</a> (including arbitration). ' +
        'Consent is not required to purchase. Msg frequency varies. Reply HELP for help, STOP to opt-out. ' +
        'View <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.'));

      /* Chi liet ke nuoc Postscript gui duoc. VN CO TINH khong co trong danh sach — Postscript
         khong gui SMS ve VN, de vao chi lam khach nhap roi ket o buoc OTP. */
      /* MA CHU 2 ky tu, KHONG dung emoji co: Windows khong co font co nen emoji regional-indicator
         hien ra o vuong — da thay tan mat trong anh chup ("□□ +1"). Loi nay dinh moi khach Windows,
         khong phai rieng may tao. Alia hien duoc co vi ho dung anh SVG chu khong phai emoji. */
      var NUOC = [['US', '+1'], ['CA', '+1'], ['GB', '+44'], ['IE', '+353'], ['AU', '+61'],
                  ['DE', '+49'], ['FR', '+33'], ['ES', '+34'], ['IT', '+39'], ['PT', '+351'],
                  ['AT', '+43'], ['BE', '+32'], ['SE', '+46'], ['CH', '+41'], ['MT', '+356']];
      var telRow = el('div', 'lbp-tel');
      var oCo = el('div', 'lbp-cc');
      var laCo = el('img', 'lbp-flag'); laCo.alt = '';
      var cc = document.createElement('select');
      cc.setAttribute('aria-label', 'Country code');
      NUOC.forEach(function (n) {
        var o = document.createElement('option');
        o.value = n[1]; o.textContent = n[0] + ' ' + n[1];
        cc.appendChild(o);
      });
      /* tra co theo selectedIndex, KHONG theo value: US va CA deu la '+1' nen tra theo
         ma vung se luon ra nham co */
      /* Mac dinh ma vung theo NUOC CUA KHACH (xem khachUS/nuocKhach ben duoi), khong phai luon US:
         khach VN thay +1 san roi go so VN vao -> luu '+1<so VN>' sai vinh vien. */
      (function () {
        var n = nuocKhach();
        for (var i = 0; i < NUOC.length; i++) if (NUOC[i][0] === n) { cc.selectedIndex = i; break; }
      })();
      function veCo() { laCo.src = CO[NUOC[cc.selectedIndex][0]] || ''; }
      veCo();
      oCo.appendChild(laCo); oCo.appendChild(el('span', 'lbp-caret')); oCo.appendChild(cc);
      var telI = el('input'); telI.type = 'tel'; telI.placeholder = 'Your phone number'; telI.autocomplete = 'tel';
      /* US/CA (+1): go toi dau dinh dang toi do -> (307) 223-2929. Nuoc khac de nguyen so vi
         moi nuoc mot kieu, dinh dang bua con kho doc hon de nguyen.
         Khong anh huong luong gui di: cho submit da strip /\D/g roi moi ghep ma vung. */
      function dinhDang(d) {
        if (cc.value !== '+1') return d;
        d = d.slice(0, 10);
        if (!d) return '';
        if (d.length <= 3) return '(' + d;
        if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
        return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
      }
      /* Dung [^0-9] chu KHONG dung \D: dong nay tung bi ghi hong thanh /D/g (mat gach cheo nguoc
         vi doan thay the nam trong heredoc LONG template literal, hai lop an mat mot cap).
         Hau qua luc do: khong strip duoc ngoac -> moi lan go lai boc them mot lop -> "(((3) 07".
         Lop ky tu [^0-9] khong co gach cheo nguoc nen khong the tai dien kieu loi nay. */
      function dinhDangLai() { telI.value = dinhDang((telI.value || '').replace(/[^0-9]/g, '')); }
      telI.addEventListener('input', dinhDangLai);
      cc.addEventListener('change', function () { veCo(); dinhDangLai(); });
      telRow.appendChild(oCo); telRow.appendChild(telI);
      var perr = el('p', 'lbp-err', '');
      var pgo = el('button', 'lbp-btn', 'Continue');

      pgo.onclick = function () {
        /* bo moi ky tu khong phai so, bo so 0 dau (dang noi dia) roi ghep ma vung */
        var so = (telI.value || '').replace(/\D/g, '').replace(/^0+/, '');
        /* Nguong theo MA VUNG, khong dung chung mot con so cho ca 15 nuoc. So US/CA bat buoc
           du 10 chu so; de nguong 7 thi khach go thieu ma vung ('223 2929') van lot qua, roi
           '+12232929' bi day vao kho lam KHOA DANH TINH thu ba — sai vinh vien va khong sua duoc,
           trong khi Postscript thi tu choi nen khach cung khong nhan duoc ma. */
        var toiThieu = (cc.value === '+1') ? 10 : 7;
        if (so.length < toiThieu) { perr.textContent = 'Please enter a valid phone number.'; return; }
        var sdt = cc.value + so;
        pgo.disabled = true; pgo.textContent = 'One moment…';

        var acq = psAcq();
        if (!acq) {
          /* Chua cai Postscript tren store nay — van luu vao kho roi di tiep. */
          emitPhone(sdt); capNhatPhoneKlaviyo(sdt);
          setSt({ phone: 1 }); render('reward'); return;
        }
        /* OTP CHI CHO US (user chot 16/09). Nuoc khac: luu sdt vao kho, goi optIn KHONG cho ket qua
           (Postscript tu gui tin double opt-in neu nuoc do trong Allow List), roi vao thang man cuoi.
           Xet theo NUOC KHACH CHON o o ma vung, KHONG xet `Shopify.country`: cai do la MARKET — do that
           16/09: may dat mui gio New York van ra 'VN', va khach EU/CA roi vao market US se bi hoi OTP oan.
           So sanh theo selectedIndex vi US va CA cung '+1'. */
        var laUS = khachUS() && NUOC[cc.selectedIndex] && NUOC[cc.selectedIndex][0] === 'US';
        if (!laUS) {
          emitPhone(sdt); capNhatPhoneKlaviyo(sdt);
          try {
            if (typeof acq.init === 'function') acq.init({});
            Promise.resolve().then(function () {
              return acq.optIn(sdt, {
                sourceName: 'Litborne popup',
                welcomeMessage: "You're in! Here's 10% off your first order: " + CODE
                  + '. Shop ' + location.hostname + ' — Reply STOP to opt out.',
              });
            }).catch(function () {});
          } catch (e) {}
          setSt({ phone: 1 }); render('reward'); return;
        }
        (function () {
          try { if (typeof acq.init === 'function') acq.init({}); } catch (e) {}
          /* Doc tu sdk.bundle.js: optIn(phone, o) CHI doc 4 tuy chon —
               h = o?.sourceKey, f = o?.welcomeMessage, g = o?.sourceId, v = o?.sourceName
             roi $x() gui len body { ..., welcome_message: f, source_name: v }.
             `source` va `shouldSubscribe` tao truyen truoc day BI BO QUA hoan toan: server nhan
             `source` tu hang so noi bo cua SDK, khong phai tu minh.
             welcomeMessage = cach Alia gui tin khuyen mai NGAY SAU tin "You're subscribed".
             CHUA CHAC: licenseKey (tu init) di kem header X-Postscript-Ooi-License-Key va chi gan
             khi co; Alia truyen licenseKey:"Alia" con ta thi khong. Server co the chi nhan
             welcome_message tu doi tac co license — doc ma client khong ket luan duoc, phai thu that. */
          /* Boc trong .then() chu KHONG goi thang ben trong Promise.resolve(): neu SDK nem loi
             DONG BO thi ngoai le thoat khoi ca IIFE nay lan onclick, khong nhanh .catch nao chay,
             ma nut thi da bi disable + doi chu 'One moment…' tu truoc -> ket cung khong mot dong
             bao loi, khach chi con cach dong popup (roi dinh tiep khoa signedUp). Rat de xay ra
             vi dong init() ngay tren CO Y nuot loi im lang, nen SDK co the o trang thai nua voi.
             Boc lai thi throw dong bo thanh rejection va nhanh .catch mo nut ra. */
          Promise.resolve().then(function () {
            return acq.optIn(sdt, {
              sourceName: 'Litborne popup',
              welcomeMessage: "You're in! Here's 10% off your first order: " + CODE
                + '. Shop ' + location.hostname + ' — Reply STOP to opt out.',
            });
          })
            .then(function (r) {
              var tt = (r && r.subscriberStatus) || 'unknown';
              emitPhone(sdt); capNhatPhoneKlaviyo(sdt);
              if (tt === 'subscribed') { setSt({ phone: 1 }); render('reward'); }
              else { pendingPhone = sdt; render('otp'); }     /* con phai xac thuc OTP */
            })
            .catch(function () {
              /* Khong nhay sang reward: man do noi "check your inbox and texts" trong khi KHONG
                 co tin nhan nao duoc gui — noi doi voi khach. Giu lai buoc nay va bao that. */
              emitPhone(sdt); capNhatPhoneKlaviyo(sdt);
              perr.textContent = 'We could not sign you up for texts right now.';
              pgo.disabled = false; pgo.textContent = 'Continue without texts';
              pgo.onclick = function () { setSt({ phone: 1 }); render('reward'); };
            });
        })();
      };
      /* Alia khong co nut bo qua o buoc nay — bo theo. Hau qua: khach khong cho so thi khong
         den duoc man reward, chi con cach dong popup. */
      telI.addEventListener('keydown', function (e) { if (e.key === 'Enter') pgo.click(); });
      box.appendChild(telRow); box.appendChild(perr);
      box.appendChild(pgo);
    }

    /* Buoc nhap ma OTP — chi hien khi Postscript tra ve trang thai chua xac thuc.
       Ma la 4 CHU SO: da xem tan mat tin nhan that tren .com 14/09, khong phai 6 nhu tao doan luc dau. */
    if (step === 'otp') {
      box.appendChild(el('h2', 'lbp-h2', 'We sent you a code'));
      box.appendChild(el('p', 'lbp-sub', 'Validate your phone number by entering the code we sent you'));
      var oerr = el('p', 'lbp-err', '');
      var ogo = el('button', 'lbp-btn', 'Activate My Discount');

      var rs = el('p', 'lbp-resend', "Didn't get a code? ");
      var rsb = el('button', null, 'Resend code');
      rsb.onclick = function () {
        var a = psAcq();
        /* resendOtp(n) -> Bx(shopId, n, ...) voi n = phone_number: tham so la CHUOI so, khong phai
           object (khac verify). Goi rong thi phone_number = undefined nen khong gui lai duoc gi.

           CHI duoc bao thanh cong khi THAT SU gui duoc. Truoc day dong 'Code sent again.' nam
           NGOAI try va khong phu thuoc dieu kien nao: SDK bien mat (bi chan quang cao / go app)
           -> a = null -> khong goi gi ma khach van doc "da gui lai" roi ngoi cho mot tin nhan
           khong bao gio den. Loi bi try nuot, hoac Promise bi tu choi, deu cho ket qua y het. */
        if (!a || typeof a.resendOtp !== 'function') {
          oerr.textContent = 'We could not resend the code.';
          return;
        }
        rsb.disabled = true;
        Promise.resolve().then(function () { return a.resendOtp(pendingPhone); })
          .then(function () { oerr.textContent = 'Code sent again.'; })
          .catch(function () { oerr.textContent = 'We could not resend the code.'; })
          .then(function () { rsb.disabled = false; });
      };
      rs.appendChild(rsb);

      var oWrap = el('div', 'lbp-otp');
      var oIns = [];
      for (var i = 0; i < 4; i++) {
        var ci = el('input');
        ci.type = 'text'; ci.inputMode = 'numeric'; ci.maxLength = 1;
        ci.setAttribute('aria-label', 'Digit ' + (i + 1));
        oWrap.appendChild(ci); oIns.push(ci);
      }
      /* go xong tu nhay o ke tiep, backspace lui lai, dan ca ma thi rai deu ra cac o */
      oIns.forEach(function (c, idx) {
        c.addEventListener('input', function () {
          c.value = (c.value || '').replace(/\D/g, '').slice(0, 1);
          if (c.value && idx < 3) oIns[idx + 1].focus();
        });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Backspace' && !c.value && idx > 0) oIns[idx - 1].focus();
          if (e.key === 'Enter') ogo.click();
        });
        c.addEventListener('paste', function (e) {
          var t = (((e.clipboardData || window.clipboardData) || {}).getData('text') || '').replace(/\D/g, '');
          if (!t) return;
          e.preventDefault();
          for (var k = 0; k + idx < 4 && k < t.length; k++) oIns[idx + k].value = t.charAt(k);
          oIns[Math.min(3, idx + t.length - 1)].focus();
        });
      });

      ogo.onclick = function () {
        var ma = oIns.map(function (c) { return c.value || ''; }).join('');
        if (ma.length < 4) { oerr.textContent = 'Please enter the 4-digit code.'; return; }
        var acq2 = psAcq();
        if (!acq2 || typeof acq2.verify !== 'function') {
          /* KHONG duoc lang le nhay sang reward: nhu vay la bao "xong" trong khi chua he xac thuc
             duoc gi — cung loai loi da sua o nhanh optIn. Va no con lam ta khong phan biet duoc
             "verify thanh cong that" voi "nhay qua" khi nhin man hinh. */
          oerr.textContent = 'We could not check your code right now.';
          ogo.disabled = false; ogo.textContent = 'Continue without texts';
          ogo.onclick = function () { setSt({ phone: 1 }); render('reward'); };
          return;
        }
        ogo.disabled = true; ogo.textContent = 'Checking…';
        /* Chu ky THAT doc tu sdk.bundle.js: verify(n, i) voi n.code va n.phoneNumber
           -> tham so 1 la OBJECT, khong phai chuoi ma. Goi verify(ma) thi ca hai truong deu
           undefined nen server luon tra that bai — do la ly do ma DUNG van bao "code did not work". */
        /* Boc trong .then() chu KHONG goi thang trong Promise.resolve(): neu SDK nem loi DONG BO
           (vd init chua thanh cong nen shopId undefined) thi ngoai le thoat khoi ca onclick,
           khong nhanh .catch nao chay, ma nut thi da bi disable + doi chu tu truoc -> ket cung
           o 'Checking…' khong mot dong bao loi. Boc lai thi throw dong bo thanh rejection. */
        Promise.resolve().then(function () { return acq2.verify({ code: ma, phoneNumber: pendingPhone }); })
          .then(function () { setSt({ phone: 1 }); render('reward'); })
          .catch(function () {
            ogo.disabled = false; ogo.textContent = 'Activate My Discount';
            oerr.textContent = 'That code did not work.';
          });
      };
      box.appendChild(rs); box.appendChild(oWrap); box.appendChild(oerr); box.appendChild(ogo);
      setTimeout(function () { try { oIns[0].focus(); } catch (e) {} }, 60);
    }

    if (step === 'reward') {
      /* Y HET Alia ke ca noi dung (user chot 14/09): KHONG hien ma tren man, khong dong chu nho.
         Nut "Shop now" van tu ap ma qua /discount/ nen ai bam nut la co giam gia ngay.
         RUI RO da bao user: ai KHONG bam nut thi phai cho ma qua email/SMS, ma list Klaviyo cua .co
         hien chua gan flow nao -> nhung nguoi do khong nhan duoc ma. */
      box.appendChild(el('h2', 'lbp-h1', "You're In!"));
      box.appendChild(el('p', 'lbp-sub', 'Check your inbox and texts for your discount code'));
      var shop = el('a', 'lbp-btn', 'Shop now');
      shop.href = '/discount/' + CODE + '?redirect=/';   /* ve TRANG CHU (user chot 16/09), van tu ap ma qua /discount/ */
      box.appendChild(shop);
    }
    card.appendChild(box);
  }

  function mount() {
    if (root) return;
    ensureCss();
    root = el('div'); root.id = 'lb-pop'; root.hidden = true;
    var bg = el('div', 'lbp-bg');
    /* KHONG gan click-de-dong len nen (user chot 14/09). Da do truoc khi go: chi dung duong nay
       lam tat popup — bam vao the, o nhap so, vung chon nuoc, hay chon nuoc trong danh sach deu
       KHONG tat, tren ca desktop lan mobile va ca hai store. Nen chi can go dung dong nay.
       Giu lai chinh phan tu .lbp-bg vi no con nhiem vu ve anh nen toi.
       Sau thay doi nay nut X la duong dong DUY NHAT (quiz va phone deu da bo "No thanks"
       de giong Alia) — X co mat o moi buoc nen khong ai bi ket. */
    root.appendChild(bg);
    root.appendChild(el('div', 'lbp-card'));
    document.body.appendChild(root);
  }
  var opened = false;
  function open(lyDo) {
    if (opened || st().signedUp && debug !== '1') return;
    opened = true;
    mount();
    if (khachUS()) napPsForm();          /* nap truoc, den buoc phone khong phai cho */
    bao('popup_show', lyDo || 'khong ro');
    bao('popup_ver', 'ps-form-1' + (khachUS() ? ' us' : ' non-us'));   /* biet phien nay chay ban nao (17/09: test nham theme live) */
    render('quiz');
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    killPill();
    setSt({ lastShownAt: Date.now() });
  }
  function closeOnly() {
    if (root) root.hidden = true;
    document.documentElement.style.overflow = '';
    opened = false;
  }
  function dismiss() {
    /* wasReward cu do '.lbp-code' -> khoi hien ma da bo khi lam giao dien y het Alia,
       nen no LUON false. Dung moc that: da toi buoc reward hay chua. */
    var wasReward = buocHienTai === 'reward';
    bao('popup_close', buocHienTai || 'khong ro');
    closeOnly();
    /* noPill: 0 — bam X thi van hien floating; chi "No thanks" hoac x tren pill moi tat floating */
    if (!wasReward && !st().signedUp) { setSt({ dismissedAt: Date.now(), noPill: 0 }); showPill(); }
  }
  /* "No thanks" o buoc 1: dong 7 ngay nhu X, nhung KHONG floating (y Alia). */
  function noThanks() {
    bao('popup_close', 'no_thanks');
    closeOnly();
    if (!st().signedUp) setSt({ dismissedAt: Date.now(), noPill: 1 });
  }

  /* ---------- floating pill (sau khi dismiss) ---------- */
  var pill = null;
  function showPill() {
    if (pill || st().signedUp || st().noPill) return;
    ensureCss();
    pill = el('div'); pill.id = 'lb-pill';
    var mo = el('button', 'lbp-pill-open', "You've got a gift! 🎁");
    mo.onclick = function () { open('pill'); };
    /* x tren pill: tat floating cho den het han 7 ngay (cung moc voi dismissedAt) */
    var x = el('button', 'lbp-pill-x', '✕'); x.setAttribute('aria-label', 'Hide');
    x.onclick = function (ev) { ev.stopPropagation(); bao('popup_close', 'pill_x'); setSt({ noPill: 1 }); killPill(); };
    pill.appendChild(mo); pill.appendChild(x);
    document.body.appendChild(pill);
  }
  function killPill() { if (pill) { pill.remove(); pill = null; } }

  /* ---------- Klaviyo subscribe (client endpoint, khong can secret) ---------- */
  /* ---------- khoa thu HAI cua kho du lieu: email ----------
     Client ID (_shopify_y) chet khi khach doi may hoac xoa cookie. Thay WL71:
     lay email o thiet bi 1 roi noi vao client ID moi o thiet bi 2 -> van la mot nguoi,
     van quy dung ve campaign. Popup chinh la cho lay email do.
     Ban ten su kien 'lead' — CO Y khong nam trong danh sach gui Meta, chi vao kho. */
  /* Doc ma phien do script theme (lb-px.js) so huu.
     Khong co cai nay thi dong `lead` trong lb.events rong session_id — do that: 124/124 dong
     deu rong — nen email/phone khong noi duoc vao phien ma no phat sinh, mat nua gia tri cua
     khoa danh tinh. Khong dung regex (bay escape da dinh 4 lan trong phien nay).
     CO Y khong gop chung voi doan doc trong bao(): bao() vua kiem xong va dang chay dung,
     khong dung vao thu dang chay tot khi di sua thu khac. */
  function docPhien() {
    try { var o = JSON.parse(localStorage.getItem('_lbx_sess') || 'null'); return (o && o.id) || ''; }
    catch (e) { return ''; }
  }
  function emitIdentity(email, name) {
    try {
      var cfg = window.__lbpx || {};
      var url = cfg.collect || 'https://api.litborne.com/px/e';
      var ck = function (n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m[2]) : ''; };
      var cid = maKhach(ck('_shopify_y'));
      if (!cid) return;
      var P = window.Shopify && window.Shopify.customerPrivacy;
      /* Doc khong ra API dong y -> COI NHU CO phan tich, dung chinh sach da chot cua du an
         ("doc khong ra thi cho chay phan phan tich, nhung KHONG ban Meta") va dung voi hai
         nguon ghi kia (theme + web pixel deu mac dinh true). Truoc day cho nay mac dinh FALSE
         nen popup tu coi khach la da tu choi roi im lang bo su kien — chi vi API privacy chua
         kip nap. Hau qua do duoc: phieu popup dem THIEU so voi thuc te, va hai script ghi cung
         mot bang lb.activity lai mac dinh nguoc nhau. Rieng `cm` van giu mac dinh FALSE. */
      var ca = P ? !!P.analyticsProcessingAllowed() : true;
      var cm = P ? !!P.marketingAllowed() : false;
      if (!ca) return;                       /* EU/UK chua dong y thi khong luu gi */
      var parts = String(name || '').trim().split(/\s+/);
      var body = {
        name: 'lead', src: 'web', ts: Date.now(),
        shop: cfg.shop || (window.Shopify && window.Shopify.shop) || location.hostname,
        cid: cid, sy: cid, sid: docPhien(),
        email: email,
        first_name: parts[0] || '',
        last_name: parts.length > 1 ? parts[parts.length - 1] : '',
        country: (window.Shopify && window.Shopify.country) || '',
        url: location.href.slice(0, 300),
        path: location.pathname.slice(0, 200),
        fbc: ck('_fbc'), fbp: ck('_fbp'),
        ca: ca, cm: cm
      };
      var s = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([s], { type: 'text/plain' }));
      else { var r = new XMLHttpRequest(); r.open('POST', url); r.setRequestHeader('Content-Type', 'text/plain'); r.send(s); }
    } catch (e) { /* do luong khong duoc lam hong popup */ }
  }

  /* Day SO DIEN THOAI vao kho lam KHOA DANH TINH THU BA (cung client_id va email).
     Doc lap hoan toan voi Postscript: kho nhan duoc ngay ca khi chua cai app SMS nao. */
  function emitPhone(phone) {
    try {
      var cfg2 = window.__lbpx || {};
      var url = cfg2.collect || 'https://api.litborne.com/px/e';
      var ck2 = function (n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m[2]) : ''; };
      var cid = maKhach(ck2('_shopify_y'));
      if (!cid) return;
      var P = window.Shopify && window.Shopify.customerPrivacy;
      /* Doc khong ra API dong y -> COI NHU CO phan tich, dung chinh sach da chot cua du an
         ("doc khong ra thi cho chay phan phan tich, nhung KHONG ban Meta") va dung voi hai
         nguon ghi kia (theme + web pixel deu mac dinh true). Truoc day cho nay mac dinh FALSE
         nen popup tu coi khach la da tu choi roi im lang bo su kien — chi vi API privacy chua
         kip nap. Hau qua do duoc: phieu popup dem THIEU so voi thuc te, va hai script ghi cung
         mot bang lb.activity lai mac dinh nguoc nhau. Rieng `cm` van giu mac dinh FALSE. */
      var ca = P ? !!P.analyticsProcessingAllowed() : true;
      if (!ca) return;                       /* EU/UK chua dong y thi khong luu */
      var body = {
        name: 'lead', src: 'web', ts: Date.now(),
        shop: cfg2.shop || (window.Shopify && window.Shopify.shop) || location.hostname,
        cid: cid, sy: cid, sid: docPhien(),
        phone: phone,
        country: (window.Shopify && window.Shopify.country) || '',
        url: location.href.slice(0, 300), path: location.pathname.slice(0, 200),
        fbc: ck2('_fbc'), fbp: ck2('_fbp'),
        ca: ca, cm: P ? !!P.marketingAllowed() : false
      };
      var s = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([s], { type: 'text/plain' }));
      else { var r = new XMLHttpRequest(); r.open('POST', url); r.setRequestHeader('Content-Type', 'text/plain'); r.send(s); }
    } catch (e) {}
  }

  /* ---------- KHACH O DAU? (quyet dinh OTP: user chot 16/09 "OTP chi cho US, con lai bo") ----------
     Ba cach da thu, hai cach dau SAI:
       - `Shopify.country`: la MARKET, khong phai vi tri. Khach EU/CA roi vao market US -> bi OTP oan.
       - Nuoc khach CHON o o ma vung: mac dinh la US, khach VN de nguyen +1 -> bi OTP (user dinh that 16/09).
     Cach nay: MUI GIO cua trinh duyet — sat vi tri that nhu geo-IP cua Alia ma khong can goi API ngoai.
     VN -> Asia/Ho_Chi_Minh, EU -> Europe/*, My -> America/New_York|Chicago|Denver|Los_Angeles|...
     Khong doc duoc mui gio thi moi lui ve Shopify.country. */
  var TZ_US = /^(America\/(New_York|Detroit|Kentucky\/|Indiana\/|Chicago|Menominee|North_Dakota\/|Denver|Boise|Phoenix|Los_Angeles|Anchorage|Juneau|Sitka|Metlakatla|Yakutat|Nome|Adak)|Pacific\/Honolulu|US\/)/;
  function muiGio() { try { return String(Intl.DateTimeFormat().resolvedOptions().timeZone || ''); } catch (e) { return ''; } }
  function khachUS() {
    if (debug === '1' && qs('lbus') === '1') return true;   /* link test: ?lbpopup=1&lbus=1 ep nhanh US (user hoi 16/09) */
    var tz = muiGio();
    if (tz) return TZ_US.test(tz);
    return String((window.Shopify && window.Shopify.country) || '').toUpperCase() === 'US';
  }
  /* Ma nuoc 2 ky tu de chon mac dinh o ma vung: US neu o My; khong thi theo market cua Shopify (GB/DE/...). */
  function nuocKhach() {
    if (khachUS()) return 'US';
    return String((window.Shopify && window.Shopify.country) || '').toUpperCase();
  }

  /* ---------- FORM NHUNG CUA POSTSCRIPT cho buoc SDT (17/09/2026) ----------
     Vi sao: `acquisition.optIn/verify` cua SDK KHONG tao subscriber cho form tu lam (Postscript xac nhan 17/09:
     "not a documented supported method"; do that 16/09: 16 khach US verify OK ma 0 opt-in). Duong duoc ho tro
     tren goi Starter la Embedded Form cua chinh Postscript: <postscript-embedded-form shop-id form-id> +
     embeddedForm.bundle.js — chay OOI tron goi (so -> OTP -> success), co keyword/source, welcome message.
     Da thu that 17/09 tren litborne.com: web component render duoc khi CHEN DONG (Lit, shadow DOM MO, khong
     iframe, 1 input tel + nut submit, co the <div role=status>"Current step: X"). Nen: bo o so + man OTP cua
     minh (US), dat form nay vao card popup, ep style qua <style> ben trong shadowRoot, va nhan biet xong bang
     text "Current step: Success". So dien thoai doc tu input trong shadow de van ghi Klaviyo + kho nhu cu.
     Non-US giu UI cu (Postscript khong gui duoc cho phan lon nuoc ngoai US/CA). Form khong len duoc trong
     PS_CHO_MS (script bi chan) -> psFormHong = true -> render lai bang UI cu, khong ai bi ket. */
  var PS_SHOP = '964410', PS_FORM = '0b347782-4c46-4d3f-99f9-9ce2a4377d23', PS_CHO_MS = 6000;
  var psFormHong = false, psScriptDaNap = false;
  function napPsForm() {
    if (psScriptDaNap) return; psScriptDaNap = true;
    var s = document.createElement('script'); s.src = 'https://sdk.postscript.io/embeddedForm.bundle.js'; s.async = true;
    s.onerror = function () { psFormHong = true; };
    document.head.appendChild(s);
  }
  /* Style ep vao shadowRoot: lop cua Postscript mang hau to ngau nhien (heading-<uuid>) nen bat theo tien to.
     :host([data-buoc="Success"]) = man cuoi, tieu de doi sang vang nhu .lbp-h1. Danh sach nuoc (.iti__*) de nguyen. */
  function psFormCss() {
    return '#ps-block-entity__container,[class*="block-"],[class*="overlay-"],[class*="mainPopupContainer-"]{background:transparent!important;box-shadow:none!important;border:0!important}' +
      'h2[class*="heading-"]{font-family:"Playfair Display",Georgia,serif!important;font-size:clamp(28px,3.6vw,36px)!important;line-height:1.1!important;letter-spacing:-1px;color:#fff!important;text-shadow:0 2px 16px rgba(0,0,0,.75);margin:0 0 4px!important}' +
      ':host([data-buoc="Success"]) h2[class*="heading-"]{color:' + GOLD + '!important;font-size:clamp(34px,5.5vw,52px)!important}' +
      'p[class*="text-"]{color:#fff!important;font-size:16px!important;text-shadow:0 1px 8px rgba(0,0,0,.55);margin:0 0 6px!important}' +
      'form p,form label,form span.floating-label{color:#fff!important;text-shadow:0 1px 6px rgba(0,0,0,.8)}' +
      'small[class*="small-"]{display:block;color:#fff!important;opacity:.88;font-size:10.5px!important;line-height:1.5!important;text-shadow:0 1px 6px rgba(0,0,0,.85);margin:6px 0 8px!important}small[class*="small-"] a{color:' + GOLD + '!important}' +
      /* nhan noi cua Postscript co NEN XAM (#ececec) de len o nhap trang -> hop xam ben trong hop trang (user thay 17/09) */
      'span.floating-label{display:none!important}' +   /* dung placeholder cua minh thay nhan noi (hai chu chong nhau) */
      'input[type="tel"]{box-shadow:none!important;outline:none!important;height:50px!important;padding:0 14px!important}input[type="tel"]:focus{box-shadow:0 0 0 2px ' + GOLD + '!important}' +
      'ps-phone-input-block-iti-wrapper,ps-floating-label,.iti{background:transparent!important;box-shadow:none!important;border:0!important}' +
      /* loi inline cua form (vd "previously opted out — text START to ..."): mau do sam cua Postscript tren nen toi khong doc duoc (do that 17/09) */
      '.block-error,[role="alert"]{color:#ffd6d6!important;background:rgba(0,0,0,.45);padding:6px 10px;border-radius:4px;font-size:12px!important;line-height:1.4;text-shadow:none!important;margin:6px 0}.block-error:empty,[role="alert"]:empty{display:none!important}' +
      'form p[class*="text-"] a,a[class*="link-"]{color:' + GOLD + '!important}' +
      'input[type="tel"],input[type="text"],input[type="number"]{background:#fff!important;color:#1a1a1a!important;border-radius:6px!important;border:0!important;font-size:16px!important}input::placeholder{color:#777!important}' +
      /* intl-tel-input cua Postscript: o nhap (nen duc) de LEN nut co/ma vung -> khong bam duoc, co lap lo
         (user thay 17/09; do that: elementFromPoint tai la co tra ve INPUT). Nang nut co len tren va chua cho ben trai. */
      /* Do that: o nhap (bg duc) luon nam TREN nut co/ma vung trong form Postscript (elementFromPoint tai la co
         = INPUT du z-index the nao) -> khach khong bam doi nuoc duoc, co lap lo khi focus (user thay 17/09).
         Nhanh nay CHI cho khach US, nen an han bo chon nuoc va ep +1 US bang code (mo dropdown -> click li US, da do OK). */
      '.iti__country-container{display:none!important}.iti__tel-input{padding-left:14px!important}' +
      /* chi nut SUBMIT vang; nut phu (Resend code) = link gach chan chu trang (user 17/09: resend bi vang giong nut chinh) */
      'button[type="submit"]{background:' + GOLD + '!important;color:#1a1a1a!important;font-family:"Playfair Display",Georgia,serif!important;font-weight:700!important;text-transform:uppercase;letter-spacing:.5px;border-radius:6px!important;border:0!important;font-size:16px!important;padding:14px 18px!important}' +
      'button[class*="button-"]:not([type="submit"]){background:transparent!important;color:#fff!important;text-decoration:underline;font:14px/1.3 system-ui,sans-serif!important;padding:2px 4px!important;border:0!important;text-transform:none!important;letter-spacing:0!important;text-shadow:0 1px 6px rgba(0,0,0,.8);box-shadow:none!important;width:auto!important}' +
      'button[class*="button-"] a{color:inherit!important;text-decoration:none}' +
      '.lbp-pscc{position:relative;z-index:30;display:flex;justify-content:center;margin:0 0 6px}.lbp-pscc-btn{display:inline-flex;align-items:center;gap:7px;background:transparent;border:0;color:#fff;font:600 14px/1 system-ui,sans-serif;padding:6px 8px;cursor:pointer;text-shadow:0 1px 6px rgba(0,0,0,.8)}.lbp-pscc .lbp-flag{width:22px;height:16px;border-radius:2px;box-shadow:0 0 0 1px rgba(0,0,0,.25)}.lbp-pscc .lbp-caret{width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:5px solid #fff}' +
      '';
  }
  function psForm(box) {
    napPsForm();
    if (psFormHong) return false;
    var host = document.createElement('postscript-embedded-form');
    host.setAttribute('shop-id', PS_SHOP); host.setAttribute('form-id', PS_FORM);
    host.className = 'lbp-ps';
    host.style.visibility = 'hidden';      /* an den khi da ep style + chon nuoc -> khong "flash" hop trang (user thay 17/09) */
    /* Bo chon nuoc CUA MINH (co SVG + ma vung, y nhu UI cu) dat ngay tren o nhap cua Postscript, vi nut co cua
       Postscript bi o nhap de len khong bam duoc. Doi nuoc -> dieu khien intl-tel-input ben trong shadow bang code
       (mo dropdown roi click muc nuoc — ITI chi nhan click khi dropdown dang mo; da do OK 17/09). */
    var NUOC_PS = [['US', '+1', 'United States'], ['CA', '+1', 'Canada'], ['GB', '+44', 'United Kingdom'], ['IE', '+353', 'Ireland'], ['AU', '+61', 'Australia'],
                   ['DE', '+49', 'Germany'], ['FR', '+33', 'France'], ['ES', '+34', 'Spain'], ['IT', '+39', 'Italy'], ['PT', '+351', 'Portugal'],
                   ['AT', '+43', 'Austria'], ['BE', '+32', 'Belgium'], ['SE', '+46', 'Sweden'], ['CH', '+41', 'Switzerland'], ['MT', '+356', 'Malta']];
    /* `chon` = nuoc dang chon; hang bam = co + ma vung + mui ten; bam thi mo danh sach CO CO
       (user 17/09: <select> goc khong hien duoc co trong list). */
    var chon = { value: 'US' };
    var hang = el('div', 'lbp-pscc');
    var nutCoTa = el('button', 'lbp-pscc-btn'); nutCoTa.type = 'button'; nutCoTa.setAttribute('aria-label', 'Country');
    var laCo = el('img', 'lbp-flag'); laCo.alt = '';
    var maVung = el('span', 'lbp-pscc-ma', '');
    nutCoTa.appendChild(laCo); nutCoTa.appendChild(maVung); nutCoTa.appendChild(el('span', 'lbp-caret'));
    var danhSach = el('div', 'lbp-cclist'); danhSach.hidden = true;
    NUOC_PS.forEach(function (n) {
      var muc = el('button', 'lbp-ccitem'); muc.type = 'button';
      var im = el('img', 'lbp-flag'); im.src = CO[n[0]] || ''; im.alt = '';
      muc.appendChild(im); muc.appendChild(el('span', 'lbp-ccname', n[2])); muc.appendChild(el('span', 'lbp-ccdial', n[1]));
      /* setTimeout: goi chonNuocITI SAU khi su kien click nay ket thuc. Goi ngay thi dropdown ITI vua mo bang code da bi
         chinh click nay (dang noi len document) dong lai "vi bam ra ngoai" -> muc nuoc khong duoc chon (do that 17/09). */
      muc.onclick = function () { chon.value = n[0]; veCoPs(); danhSach.hidden = true; setTimeout(function () { if (host.shadowRoot) chonNuocITI(host.shadowRoot, n[0]); }, 30); };
      danhSach.appendChild(muc);
    });
    function veCoPs() {
      laCo.src = CO[chon.value] || '';
      for (var i = 0; i < NUOC_PS.length; i++) if (NUOC_PS[i][0] === chon.value) maVung.textContent = NUOC_PS[i][0] + ' ' + NUOC_PS[i][1];
    }
    veCoPs();
    /* Danh sach dat NGOAI shadow (trong #lb-pop, position:fixed theo toa do nut co): de trong shadow thi cac khoi sau
       cua Postscript (stacking context rieng) de len, click khong toi (do that 17/09: elementFromPoint = <small> consent). */
    function datViTriDs() {
      var r = nutCoTa.getBoundingClientRect();
      danhSach.style.top = Math.round(r.bottom + 4) + 'px';
      danhSach.style.left = Math.round(Math.max(8, Math.min(window.innerWidth - 248, r.left + r.width / 2 - 120))) + 'px';
    }
    nutCoTa.onclick = function (ev) { ev.stopPropagation(); if (danhSach.hidden) datViTriDs(); danhSach.hidden = !danhSach.hidden; };
    document.addEventListener('click', function (ev) { if (!danhSach.hidden && !danhSach.contains(ev.target)) danhSach.hidden = true; }, true);
    hang.appendChild(nutCoTa);
    root.appendChild(danhSach);
    box.appendChild(host);   /* `hang` se duoc dua VAO shadowRoot ngay tren o nhap (xem cho()), de nam duoi tieu de cua form */
    /* Dinh dang so khi go cho US/CA: (307) 223-2929 nhu popup dang live. Postscript doc value luc submit -> ngay TRUOC
       khi no doc (capture click nut submit / Enter) tra ve toan chu so, xong moi de no xu ly. */
    function dinhDangPs(d) { d = d.slice(0, 10); if (!d) return ''; if (d.length <= 3) return '(' + d; if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3); return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6); }
    function chiSo(sr) { var ip = sr.querySelector('input[type="tel"]'); if (ip && /[^0-9]/.test(ip.value)) { ip.value = ip.value.replace(/[^0-9]/g, ''); } }
    function goSo(sr, ev) {
      var ip = ev && ev.composedPath ? ev.composedPath()[0] : null;
      if (!ip || ip.type !== 'tel') return;
      if (chon.value !== 'US' && chon.value !== 'CA') return;
      var so = String(ip.value || '').replace(/[^0-9]/g, '');
      var moi = dinhDangPs(so); if (ip.value !== moi) ip.value = moi;
    }
    function chonNuocITI(sr, ma, lan) {
      try {
        var nut = sr.querySelector('.iti__selected-country');
        /* intl-tel-input co the chua boc xong input luc form vua len -> thu lai toi ~2 s */
        if (!nut) { if ((lan || 0) < 12) setTimeout(function () { chonNuocITI(sr, ma, (lan || 0) + 1); }, 160); return; }
        nut.click();
        setTimeout(function () { try {
          /* Mobile (<= ~500px): intl-tel-input mo dropdown kieu FULLSCREEN, gan vao document.body (ngoai shadow)
             -> tim muc nuoc o ca hai noi. Popup fullscreen do bi an bang CSS .iti--container trong ensureCss(). */
          var li = sr.querySelector('li[data-country-code="' + ma.toLowerCase() + '"]');
          if (!li) { var cac = document.querySelectorAll('.iti--container li[data-country-code="' + ma.toLowerCase() + '"]'); li = cac.length ? cac[cac.length - 1] : null; }   /* nhieu container (cai cu con sot) -> cai cuoi la cai dang mo */
          if (li) li.click();
          var ip = sr.querySelector('input[type="tel"]'); if (ip) { ip.placeholder = 'Phone number'; ip.blur(); if (ma !== 'US' && ma !== 'CA') ip.value = ip.value.replace(/[^0-9]/g, ''); else ip.value = dinhDangPs(ip.value.replace(/[^0-9]/g, '')); }
          docSdt(sr);
        } catch (e) {} }, 120);
      } catch (e) {}
    }
    var xong = false, sdt = '', buocCu = '', t0 = Date.now(), obs = null;
    function huy() { if (obs) { obs.disconnect(); obs = null; } try { danhSach.remove(); } catch (e) {} }
    function docSdt(sr) {
      try {
        var inp = sr.querySelector('input[type="tel"]'); if (!inp) return;
        var so = String(inp.value || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
        var dc = sr.querySelector('.iti__selected-dial-code'); var ma = dc ? String(dc.textContent || '').replace(/[^0-9]/g, '') : '';
        if (!ma) { for (var i = 0; i < NUOC_PS.length; i++) if (NUOC_PS[i][0] === chon.value) ma = NUOC_PS[i][1].replace('+', ''); }
        if (so.length >= 7) sdt = '+' + ma + so;
      } catch (e) {}
    }
    function buoc(sr) {
      var st = sr.querySelector('[role="status"]');
      var t = st ? String(st.textContent || '') : '';
      return t.indexOf('Current step:') >= 0 ? t.split('Current step:')[1].trim() : '';
    }
    function anAlertRong(sr) {
      try { sr.querySelectorAll('[role="alert"],.block-error').forEach(function (e) { e.style.display = String(e.textContent || '').trim() ? '' : 'none'; }); } catch (e) {}
    }
    function theoDoi(sr) {
      anAlertRong(sr);
      var b = buoc(sr);
      if (b && b !== buocCu) {
        buocCu = b; host.setAttribute('data-buoc', b);
        if (/verify/i.test(b)) bao('popup_step', 'otp');
        if (/success/i.test(b) && !xong) {
          xong = true; huy();
          docSdt(sr);
          bao('popup_step', 'ps_ok');
          if (sdt) { emitPhone(sdt); capNhatPhoneKlaviyo(sdt); }
          setSt({ phone: 1 });
          /* de khach thay man success cua Postscript mot nhip roi moi sang man reward cua minh */
          setTimeout(function () { if (buocHienTai === 'phone') render('reward'); }, 1200);
        }
      }
    }
    (function cho() {
      if (xong || buocHienTai !== 'phone') return;
      var sr = host.shadowRoot;
      /* "San sang" = da co the trang thai buoc (co o MOI buoc, ke ca Success). Truoc day doi o nhap/nut submit:
         khach DA la subscriber (cookie Postscript) thi form nhay thang sang Success — khong co input -> doi 6 s
         roi tuong form hong -> roi ve man OTP cu (user dinh 17/09). */
      var inp = sr && sr.querySelector('[role="status"],input,button');
      if (sr && inp) {
        if (!sr.querySelector('style[data-lbp]')) { var stl = document.createElement('style'); stl.setAttribute('data-lbp', '1'); stl.textContent = psFormCss(); sr.appendChild(stl); }
        sr.addEventListener('input', function (ev) { goSo(sr, ev); docSdt(sr); }, true);
        sr.addEventListener('change', function () { docSdt(sr); }, true);
        /* capture: chay TRUOC handler submit cua form -> tra ve chu so cho Postscript doc; dong danh sach nuoc */
        sr.addEventListener('click', function (ev) { var p = ev.composedPath ? ev.composedPath() : []; var laSubmit = p.some(function (x) { return x && x.tagName === 'BUTTON' && x.type === 'submit'; }); if (laSubmit) chiSo(sr); }, true);
        sr.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') chiSo(sr); }, true);
        /* Dua bo chon nuoc vao trong shadow, ngay TREN khoi o nhap (duoi tieu de + dong phu cua form) */
        try { var wrapPs = sr.querySelector('ps-phone-input-block-iti-wrapper'); var blk = wrapPs && wrapPs.closest('[class*="block-"]'); if (blk && blk.parentNode) blk.parentNode.insertBefore(hang, blk); else box.insertBefore(hang, host); } catch (e) { box.insertBefore(hang, host); }
        /* Mac dinh US (khach US theo mui gio) thay vi de Postscript doan theo IP; sau do moi hien form */
        chonNuocITI(sr, chon.value);
        setTimeout(function () { host.style.visibility = ''; }, 260);
        obs = new MutationObserver(function () { docSdt(sr); theoDoi(sr); });
        obs.observe(sr, { childList: true, subtree: true, characterData: true });
        theoDoi(sr);
        return;
      }
      if (Date.now() - t0 > PS_CHO_MS) {
        /* script bi chan / form khong len -> quay ve UI cu, khong de khach ket */
        psFormHong = true; bao('popup_step', 'ps_hong');
        if (buocHienTai === 'phone') render('phone');
        return;
      }
      setTimeout(cho, 150);
    })();
    return true;
  }

  /* SDK cua Postscript neu co tren trang. .co CHUA cai Postscript nen hien tai luon rong —
     viet kieu tu do de cai app xong la tu chay, khong phai sua code lan nua.
     Alia goi dung bo ham nay: acquisition.init -> optIn -> verify/resendOtp. */
  function psAcq() {
    try {
      var p = window.postscript;
      return (p && p.acquisition && typeof p.acquisition.optIn === 'function') ? p.acquisition : null;
    } catch (e) { return null; }
  }

  function subscribe(email, name) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'litborne.com popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: name || undefined,
                properties: {
                  /* TEN PROPERTY NGUYEN VAN nhu Alia (doc tu profile that trong Klaviyo 16/09):
                     flow dang chay loc "Answer this question to start: ... equals Myself" — doi ten la
                     khach moi rot khoi flow. Gia tri cung y het: 'Myself' / 'Someone else'. */
                  'Answer this question to start: Who are you shopping for today?': quizAnswer || 'unanswered',
                  'Signup Source': 'litborne.com popup'
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      }
    };
    /* XHR thay vi fetch: ne cac wrapper fetch cua web pixel tren theme */
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('revision', '2025-04-15');
      x.onload = function () { (x.status >= 200 && x.status < 300) ? resolve() : reject(new Error('klaviyo ' + x.status)); };
      x.onerror = function () { reject(new Error('klaviyo network')); };
      x.send(JSON.stringify(payload));
    });
  }


  /* Ghi so dien thoai len PROFILE Klaviyo — y nhu Alia. Doc profile that 16/09: Alia dat `phone_number`
     tren profile email, KHONG subscribe SMS trong Klaviyo (sms = NEVER_SUBSCRIBED, list "Alia SMS" 0 profile;
     SMS di Postscript). Thieu buoc nay thi profile do popup tao trong cot Phone (user thay 16/09).
     Goi o MOI nhanh sau khi khach nhap so (US/OTP, khong US, khong co Postscript). Loi thi chi ghi vao kho. */
  function capNhatPhoneKlaviyo(phone) {
    if (!emailDaNhap || !phone) return;
    try {
      var payload = { data: { type: 'subscription', attributes: { custom_source: 'litborne.com popup',
        profile: { data: { type: 'profile', attributes: { email: emailDaNhap, phone_number: phone } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } } } };
      var x = new XMLHttpRequest();
      x.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('revision', '2025-04-15');
      x.onload = function () { if (x.status >= 300) bao('popup_phone_kl_fail', 'klaviyo ' + x.status); };
      x.onerror = function () { bao('popup_phone_kl_fail', 'network'); };
      x.send(JSON.stringify(payload));
    } catch (e) {}
  }

  /* ---------- triggers ---------- */
  function arm() {
    if (debug === '1') { open('debug'); return; }
    if (dismissedRecently) { if (!s0.noPill) showPill(); return; }
    /* Preload de luc trigger bat, nen/logo da nam trong cache — nhung CHI anh dung cho thiet bi nay.
       Do that tren .com 16/09: ban cu keo ca 3 anh (394 + 118 + 18 KB) cho moi khach moi ngay o
       DOMContentLoaded, mobile tai luon nen desktop 394 KB khong bao gio dung. Dat SAU hai chot chan tren
       de khach da tat / da dang ky khong phai tai gi ca. */
    try {
      var nen = matchMedia('(max-width:749px)').matches ? 'lb-popup-bg-m.webp' : 'lb-popup-bg.webp';
      [assetUrl(nen), assetUrl('lb-popup-logo.webp')].forEach(function (u) { var im = new Image(); im.src = u; });
    } catch (e) {}
    var fired = false;
    function fire(lyDo) { if (fired) return; fired = true; cleanup(); open(lyDo); }
    /* 1. 30s tren trang */
    var tm = setTimeout(function () { fire('30s'); }, 30000);
    /* 2. cuon qua 50% */
    function onScroll() {
      var h = document.documentElement;
      var max = h.scrollHeight - innerHeight;
      if (max > 200 && h.scrollTop / max >= 0.5) fire('scroll');
      /* 4. mobile quick scroll-up */
      var y = h.scrollTop;
      if (isMobile && y < lastY - 220 && y > 300) fire('scrollup');
      lastY = y;
    }
    var lastY = 0, isMobile = matchMedia('(max-width:749px)').matches;
    addEventListener('scroll', onScroll, { passive: true });
    /* 3. exit intent desktop */
    function onOut(e) {
      if (!isMobile && !e.relatedTarget && e.clientY <= 0) fire('exit');
    }
    document.addEventListener('mouseout', onOut);
    function cleanup() {
      clearTimeout(tm);
      removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm, { once: true });
  else arm();
})();
